module.exports = __webpack_public_path__ + "static/media/0.7ca7f2a9.jpg";